import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';

// 로컬 스토리지에서 토큰 관리
export const authService = {
  // 토큰 저장
  setToken: (token: string) => {
    localStorage.setItem('admin_token', token);
  },

  // 토큰 가져오기
  getToken: (): string | null => {
    return localStorage.getItem('admin_token');
  },

  // 토큰 제거
  removeToken: () => {
    localStorage.removeItem('admin_token');
  },

  // 관리자 로그인
  login: async (email: string, password: string) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/admin/login`, {
        email,
        password,
      });

      if (response.data.success) {
        // 디버깅: 응답 구조 확인
        console.log('🔍 로그인 응답:', response.data);

        const token = response.data.data?.token;
        if (token) {
          authService.setToken(token);
          console.log('✅ 토큰 저장 완료:', token.substring(0, 20) + '...');
        } else {
          console.error('❌ 토큰을 찾을 수 없습니다:', response.data);
        }
        return response.data;
      }
      throw new Error(response.data.message);
    } catch (error: any) {
      throw new Error(error.response?.data?.message || '로그인에 실패했습니다.');
    }
  },

  // 로그아웃
  logout: () => {
    authService.removeToken();
    window.location.href = '/login';
  },

  // 토큰 유효성 검사
  isAuthenticated: (): boolean => {
    const token = authService.getToken();
    if (!token) return false;

    try {
      // JWT 토큰 디코딩하여 만료 시간 확인
      const payload = JSON.parse(atob(token.split('.')[1]));
      const currentTime = Date.now() / 1000;
      return payload.exp > currentTime;
    } catch {
      return false;
    }
  },
};

// Axios 인스턴스 생성 (동적 토큰 사용)
export const createApiInstance = () => {
  const token = authService.getToken();

  // 디버깅: 토큰 상태 확인
  console.log('🔍 API 인스턴스 생성 - 토큰 상태:', {
    hasToken: !!token,
    tokenLength: token ? token.length : 0,
    tokenPreview: token ? token.substring(0, 20) + '...' : 'null',
  });

  return axios.create({
    baseURL: API_BASE_URL,
    headers: {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    },
  });
};
